module.exports = __webpack_public_path__ + "static/media/image-qualidade-mobile.1124258d.png";